import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { getAdjustPlanPeriod, getAssociates } from 'app/entities/common/common.reducer';
import { getEntities as getFields } from 'app/entities/field/field.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import { getEntities as getProjects } from 'app/entities/project/project.reducer';
import { getEntities as getWorkGroups } from 'app/entities/work-group/work-group.reducer';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import { Container } from 'reactstrap';
import { getEntities as getEmployees } from '../../employee/employee.reducer';
import { getEntity, updateEntityAdjustment } from '../objective.reducer';
import ObjectiveKRRowSelection from './view-row-selection/objective-kr';

type FormAdjustObjectiveType = {
  isOpen: boolean;
  onClose: (reload?: boolean) => void;
  id?: string;
  isReadOnly?: boolean;
  selectedPeriod?: number;
};

export const AdjustObjectiveUpdate = ({ isOpen, isReadOnly, onClose, id, selectedPeriod }: FormAdjustObjectiveType) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const objectiveEntity = useAppSelector(state => state.objective.entity);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const projectList = useAppSelector(state => state.project.entities);
  const workGroupList = useAppSelector(state => state.workGroup.entities);
  const employeeList = useAppSelector(state => state.employee.entities);
  const fieldList = useAppSelector(state => state.field.entities);
  const updating = useAppSelector(state => state.objective.updating);
  const updateSuccess = useAppSelector(state => state.objective.updateSuccess);
  const adjustPlanPeriods = useAppSelector(state => state.common.adjustmentPlanPeriod);
  const filtersObjective = useAppSelector(state => state.filters.objective);

  const [formData, setFormData] = useState(null);
  const [isOpenModal, setOpenModal] = useState(false);
  const [alignSelected, setAlignmentSelected] = useState([]);

  const handleClose = () => {
    form.resetFields();
    onClose(updateSuccess);
  };

  useEffect(() => {
    innitData();
  }, [isOpen]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (objectiveEntity && id) {
      setAlignmentSelected(objectiveEntity?.associateIds);
      setFormData({
        ...objectiveEntity,
        contribution: objectiveEntity.contribution && displayPercent(objectiveEntity.contribution),
      });
      form.setFieldsValue({
        ...objectiveEntity,
        contribution: objectiveEntity.contribution && displayPercent(objectiveEntity.contribution),
      });
    }
  }, [objectiveEntity]);

  const innitData = () => {
    // get detail
    dispatch(getAdjustPlanPeriod({ planPeriodId: objectiveEntity?.planPeriodId }));
    dispatch(getAssociates());
    dispatch(getFields({}));
    dispatch(getEmployees({}));
    dispatch(getWorkGroups({}));
    dispatch(getPlanPeriods({}));
    dispatch(getProjects({}));
    if (id) {
      dispatch(getEntity(id));
    }
  };

  // eslint-disable-next-line complexity
  const handleSubmit = () => {
    const entity = {
      ...objectiveEntity,
      ...formData,
      contribution: percent(formData.contribution),
      tags: _.split(formData.tags, ','),
      planTags: _.split(formData.planTags, ','),
      informEmails: _.split(formData.informEmails, ','),
    };

    dispatch(updateEntityAdjustment(entity));
  };

  const handleFormChange = (changedValues, allValues) => {
    if (changedValues.accountableId) {
      const employee = _.find(employeeList, o => {
        return o.id === changedValues.accountableId;
      });
      if (employee) {
        setFormData({
          ...allValues,
          accountableOrganizationId: employee.partyId,
        });
        return;
      }
    }
    setFormData({ ...formData, ...allValues });
  };

  const handleCloseModal = (isUpdateValue = true, itemSelected = []) => {
    if (isUpdateValue) {
      setFormData({ ...formData, associateIds: itemSelected.map(x => x.id) });
      form.setFieldValue('alignCode', itemSelected.length > 0 ? `${_.join(itemSelected.map(x => x.code), " ,")}` : null);
    }
    setOpenModal(false)
  }

  const handleOpenModalViewRowSelection = () => {
    setOpenModal(true)
  }


  return (
    <Modal
      open={isOpen}
      maskClosable={false}
      onCancel={() => {
        onClose();
      }}
      footer={null}
      width={1300}
    >
      <Container className="form">
        <Form size="large" disabled={isReadOnly} onValuesChange={handleFormChange} form={form} onFinish={handleSubmit} layout="vertical">
          <Title level={3}>{`Điều chỉnh mục tiêu ${filtersObjective?.accountableName ? filtersObjective.accountableName : ''}`}</Title>
          <Row>
            <Col md={4}>
              <Form.Item label="Kỳ kế hoạch" rules={[{ required: true, message: 'Hãy chọn kỳ kế hoạch' }]} name="planPeriodId">
                <Select
                  allowClear
                  showSearch
                  size="large"
                  filterOption={filterOption}
                  options={_.filter(planPeriodList, o => {
                    return o.planPeriodType === PlantPeriodType.Year;
                  }).map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn kỳ kế hoạch"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={4}>
              <Form.Item label="Loại kỳ" rules={[{ required: true, message: 'Hãy chọn kỳ điều chỉnh' }]} name="adjustmentPeriod">
                <Select
                  allowClear
                  showSearch
                  size="large"
                  filterOption={filterOption}
                  options={adjustPlanPeriods}
                  placeholder="Chọn kỳ điều chỉnh"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={14}>
              <Form.Item
                label="Mục tiêu, KR liên kết"
                name={'alignCode'}
              >
                <Row gutter={8} align="middle">
                  <Col flex="auto">
                    <Form.Item noStyle
                      name={'alignCode'}>
                      <Input
                        readOnly
                        size="large"
                        placeholder="Chọn mục tiêu, KR liên kết"
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button
                      className="primary"
                      size="large"
                      onClick={handleOpenModalViewRowSelection}
                      icon={<PlusOutlined />}
                    >
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <Form.Item label="Lĩnh vực" name="field">
                <Select
                  allowClear
                  showSearch
                  size="large"
                  filterOption={filterOption}
                  options={fieldList.map(x => {
                    return {
                      label: x.description,
                      value: x.value,
                    };
                  })}
                  placeholder="Chọn lĩnh vực"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Form.Item label="Dự án" name="projectId">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={projectList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn dự án"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Form.Item label="Mảng công việc" name="workTypeId">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={workGroupList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn mảng công việc"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={6}>
              <Form.Item label="Phân quyền truy cập" name={'accessIds'}>
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={employeeList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Nội dung mục tiêu" rules={[{ required: true, message: 'Hãy nhập nội dung mục tiêu' }]} name={'purpose'}>
                <TextArea
                  placeholder="Là một cụm từ phản ánh phương hướng, định hướng, kết quả mong muốn về một vấn đề cụ thể cần đạt được trong kỳ kế hoạch"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col md={11}>
              <Form.Item label="Chủ trì (Owner)" rules={[{ required: true, message: 'Hãy chọn người chủ trì' }]} name="accountableId">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={employeeList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn người chủ trì"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item label="Người nhận thông báo (cách nhau dấu phẩy)" name={'informEmails'}>
                <Input className="w-100" placeholder="Nhập người nhận thông báo" size="large" />
              </Form.Item>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Col>
          </Row>
          <Row>
            <Col md={11}>
              <Form.Item label="Tag" name={'tags'}>
                <Input className="w-100" size="large" placeholder="Nhập tag" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item label="Plan tag" name={'planTags'}>
                <Input className="w-100" size="large" placeholder="Nhập plan tag" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item
                label="Lý do điều chỉnh"
                rules={[{ required: true, message: 'Hãy nhập lý do điều chỉnh mục tiêu' }]}
                name={'reason'}
              >
                <TextArea placeholder="nhập lý do điều chỉnh mục tiêu" size="large" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Row className="action mt-3" justify="end">
              <Col>
                <Button className="primary" htmlType="submit" disabled={updating || isReadOnly}>
                  Lưu
                </Button>
              </Col>
              <Col>
                <Button
                  className="secondary"
                  onClick={() => {
                    handleClose();
                  }}
                  disabled={updating}
                >
                  Hủy
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
        {isOpenModal &&
          <ObjectiveKRRowSelection defaultSelected={alignSelected} isOpen={isOpenModal} onClose={handleCloseModal} />
        }
      </Container>
    </Modal>
  );
};

export default AdjustObjectiveUpdate;
